import {ChangeDetectorRef, Component, OnDestroy, OnInit, ViewEncapsulation} from '@angular/core';
import {FamigliaUtilsService} from '../../../../core/service/kleros/famiglia-utils.service';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {GraphLink} from '../../models/graph-data';
import {ButtonModule} from 'primeng/button';
import {RippleModule} from 'primeng/ripple';
import {InputTextModule} from 'primeng/inputtext';
import {DividerModule} from 'primeng/divider';
import {SelectButtonModule} from 'primeng/selectbutton';
import {ConfirmPopupModule} from 'primeng/confirmpopup';

import {UtilsService} from '@shared-lib';
import {TranslateModule, TranslateService} from '@ngx-translate/core';
import {ListboxModule} from 'primeng/listbox';
import {AvatarModule} from 'primeng/avatar';
import {TooltipModule} from 'primeng/tooltip';
import {ProgressSpinnerModule} from 'primeng/progressspinner';
import {Message} from 'primeng/message';
import {ReportService, StorageService} from '../../../../core/service';
import {GRAFO_DATA} from '../../../../shared/constants/app-constants';
import {environment} from '../../../../../environments/environment';
import {NodeScreenshotData} from '../../../../shared/models';
import {finalize, mergeMap, Subscription} from 'rxjs';

@Component({
	selector: 'grafo-famiglia',
	templateUrl: 'grafo-famiglia-screenshot.component.html',
	styleUrl: './grafo-famiglia-screenshot.component.scss',
	encapsulation: ViewEncapsulation.None,
	imports: [
		ButtonModule,
		RippleModule,
		InputTextModule,
		ReactiveFormsModule,
		DividerModule,
		SelectButtonModule,
		ConfirmPopupModule,
		TranslateModule,
		ListboxModule,
		AvatarModule,
		TooltipModule,
		FormsModule,
		ProgressSpinnerModule,
		Message
	]
})
export class GrafoFamigliaScreenshotComponent implements OnInit, OnDestroy {

	graphData: {nodes: NodeScreenshotData[], links: GraphLink[]}; // dati "completi" in arrivo da routing

	nodes: NodeScreenshotData[];
	links: GraphLink[];

	loadingGrafoLocal = false;
	subscriptions: Subscription = new Subscription();

	constructor(public utils: UtilsService,
							protected famigliaUtils: FamigliaUtilsService,
							private storage: StorageService,
							private reportService: ReportService,
							private translate: TranslateService,
							private cdRef: ChangeDetectorRef) {
	}

	ngOnInit() {
		if (environment.ambiente === 'LOCAL') {
			if (!this.storage.hasItemSession(GRAFO_DATA)) {
				this.loadingGrafoLocal = true;
				// x test: localhost carico qui i dati se ancora non sono stati caricati...
				this.subscriptions.add(this.reportService.getDatiGrafoFamiglia(this.translate.currentLang)
					.pipe(finalize(() => this.loadingGrafoLocal = false))
					.subscribe(graphData => {
						this.graphData = graphData;
						this.initGraphData();
					}));
			} else {
				window.postMessage(JSON.parse(this.storage.getItemSession(GRAFO_DATA)));
			}
		}
		window.addEventListener('message', event => {
			this.graphData = event.data; // arriva direttamente il json nel message
			if (this.utils.checkValid(this.graphData)) {
				this.initGraphData();
			}
		});
		window['messageListenerOK'] = true;
		document.body.classList.remove('body-bg-color');
	}

	ngOnDestroy() {
		// sennò rimangono
		this.links.forEach(l => l.link.remove());
		document.body.classList.add('body-bg-color');
	}

	private initGraphData() {
		if (this.graphData) {
			// 1) prima creo TUTTI i nodi del grafo (compresa radice)
			this.nodes = this.graphData.nodes.filter(n => n.includi); // assegno e verranno disegnati nel DOM (con le coordinate x,y iniziali)
			// 2) poi creo i link tra i nodi:
			this.links = this.graphData.links || [];
			if (this.links.length > 0) {
				this.cdRef.detectChanges();
				// disegno i link con libreria leader-line
				setTimeout(() => {
					try {
						this.links.forEach(link => {
							if (link && link.idStart && link.idEnd) {
								this.famigliaUtils.createAndDrawLinkForScreenshot(link.idStart, link.idEnd, link.linkLabel);
							}
						});
					} catch (error) {
						console.error('Errore nel disegno dei link:', error);
					} finally {
						// this.refreshAllLinks();
						window['screenshotOK'] = true;
					}
				}, 0);
			} else {
				this.cdRef.detectChanges();
				setTimeout(() => window['screenshotOK'] = true, 0);
			}
		}
	}

}

